<h2>Actief Letsen</h2>
<div class="overzicht">
    <p>Overzicht</p>
    <ul><li><a href="#actief_letser" rel="noreferrer">Hoe word ik een actief LETSer?</a></li>
        <li><a href="#excuses" rel="noreferrer">5 (slechte) excuses om niet te Letsen</a></li>
        <li><a href="#weinig_tijd" rel="noreferrer">Tips voor Letsers met weinig tijd</a></li>
    </ul>
</div>


    <h2><a name="actief_letser">Hoe word ik een actief LETSer?</a></h2><br>
        <ul><li><b>Lezen &hellip; en gewoon aan LETS denken ;-)</b><br>
        <br>
        Als lid van onze LETSgroep kan je inloggen op LetsC, onze LETSsite.<br>
        In LetsC vind je de vragen en aanbiedingen van de andere LETSers en hun
        contactgegevens. <br>
        <br>
        Lees regelmatig wat anderen vragen en aanbieden en reageer op dingen die jou interesseren.
        Wacht niet tot anderen zelf contact opnemen met jou. De ervaring leert
        dat de nieuwkomers met de meeste zin voor initiatief snel actieve nieuwe LETSers worden.<br>
        Je ontvangt wekelijks een mail met de nieuwste vraag en aanbod.
        <br>
        <br>
        Laat je niet afschrikken als het eens minder klikt met iemand. Met sommige LETSers zal het onmiddellijk klikken, met anderen niet.<br>
        <br>
        </li><li><b>LETSen &hellip; al doende leert men &hellip;</b><br>
        <br>Aarzel niet om eerst al ietsen uit te geven en er dan pas te verdienen (Je kreeg er toch 100 om mee te starten, en je mag onder nul gaan, zonder dat je rente moet betalen). Belangrijk is dat je gewoon begint te LETSen en wat LETSers leert kennen. Zij kunnen je ook tips geven over wie welke dienst vraagt of aanbiedt. En zodra je wat mensen kent, is de bal aan het rollen.<br>
        <br>
        </li><li><b>Activiteiten</b><br>
        <br>
        De makkelijkste manieren om in contact te komen met andere LETSers, is simpelweg door te LETSen of door deel te nemen aan een of andere LETS-activiteit. De LETS-activiteiten worden aangekondigd via mail en bij het nieuws in LetsC. </li></ul><br>
        <br>
    
        <h2><a name="excuses">5 (slechte) excuses om niet te LETSen</a></h2><ul>
            <li><b>Ik heb geen tijd</b><br>
        <br>
        &quot; Mijn appelboom doet het goed. Het teveel gaat naar de liefhebbers in de LETSgroep. Dat vraagt mij geen extra tijd. Een LETSer kwam helpen op het verjaardagsfeestje van m'n dochtertje. Even een adempauze voor mezelf tijdens zo'n drukke namiddag, dan heb ik zelfs veel tijd gewonnen!&quot;<br>
        <br>
        &quot; Gisteren kreeg ik Maartens computer terug in gang. Nu kan hij verder werken aan zijn eindwerk.  De ietsen die ik verdiende geef ik zaterdag aan Tim. Hij komt dan eens helpen in de tuin zodat het werk veel vlugger klaar is.&quot;
<br>
        <br>
        In het begin lijkt LETSen tijd te vragen. Je weet nog niet precies wat je kan vragen, hoe je LETS moet integreren in je dagdagelijkse bezigheden. Na een tijdje komt dit vanzelf goed. Je weet dat je af en toe aan LETS moet denken want dat daar mogelijkheden zijn.<br>
        <br>
        </li><li><b>Ik heb niets te bieden!</b><br>
        <br>
        "Ik dacht dat ik niets te bieden had tot ik in contact kwam met een gezin LETSers uit m'n buurt. Nu giet ik hun planten als ze met verlof zijn. Ik laat ook regelmatig hun hond uit."
        <br>
        <br>
        Het zit &apos;m in de simpele dingen. Je hoeft niet professioneel te zijn. Denk aan je hobby's en je talenten ... wat doe je graag? Je kan ook materiaal uitlenen Je hoeft er dus niet over te piekeren, je aanbod groeit vanzelf.<br>
        <br>
        </li><li><b>Mijn aanbod interesseert niemand</b><br>
        <br>
        &quot;Bob geeft dansles. Hij danst als de beste. Maar blijkbaar heeft niemand in de groep nu tijd en zin in dansles.&quot; <br>
        Haal je aanbod niet weg omdat niemand erop in gaat. Wat vandaag niet past, past misschien morgen wel. Of er komt een nieuw lid bij dat gek is op dansen&hellip; Intussen kan je creatief zijn. LETSers uitnodigen om te komen eten bij jou thuis, een filmavondje organiseren, gewoon ingaan op de vragen van anderen &hellip;<br>
        <br>
        </li>
        <li><b>Ik heb eigenlijk niets nodig</b><br>
        <br>
        Toegegeven, dat siert je. Maar misschien heb je nooit geleerd jezelf eens te verwennen. Een lekkere voetmassage of een maaltijd afhalen of een georganiseerde samenkomst doet iedereen deugd.<br>
        <br>
        En soms dacht je er nog niet aan &hellip; Ik besefte niet dat ik heel blij zou zijn als ik een fietsenrek zou kunnen gebruiken. Tot ik las dat Bob een fietsenrek uitleent. Nu hoef ik mij dat niet te kopen.<br>
        <br>
        </li>
        <li><b>Wat als ik teveel in min sta?</b><br>
        <br>
        "Anja had een arm gebroken. Ze kreeg hulp via LETS en kon weinig terugdoen in die periode. Ze ging behoorlijk onder nul. En wat dan nog? Eenmaal die arm weer beter is, haalt ze dat wel in."<br>
        <br>
        Je moet juist weten dat het systeem stopt op min 500 ... en dat je later veel moet terugdoen natuurlijk.</li></ul>
        <br>
        <br>
        <h2><a name="weinig_tijd">Tips voor LETSers met weinig tijd</a></h2><ul>
            <li>Laat je wasmachine, computer, videocamera, hogedrukreiniger,&hellip;<br>
        gebruiken door andere Letsers.<br>
        <br>
        </li><li>Leen je behangtafel, stellingen, cd's, boeken,&hellip; uit.<br>
        <br>
        </li><li>Als je voor jezelf kookt, maak dan een extra portie klaar en nodig een andere LETSer uit.<br>
        <br>
        </li><li>Als je kinderen hebt, bied dan kinderopvang aan. <br>
        <br>
        </li><li>Hou je van dieren? Dan kan je op het huisdier van een andere LETSer passen wanneer die op reis gaat.<br>
        <br>
        </li><li>Heb je een abonnement op een tijdschrift? Misschien hebben anderen hier ook wel interesse voor.<br>
        <br>
        </li><li>Groenten uit je eigen tuin, eieren van je kippen, zelfgebakken brood, plantenstekjes,&hellip; Je kan er allemaal ietsen voor krijgen.<br>
        <br>
        </li><li>Sommige LETSers hebben geen auto. Stel voor geïnteresseerden mee te nemen als je boodschappen gaat doen. Of misschien kan je eens iets meebrengen &hellip; of iets transporteren.<br>
        <br>
        </li></ul>
    